const enterTicketsCounterTemplate = require('./enterticketscounter.handlebars');

function getExtraChancesEntryCount(startDate,endDate) {
	
    let requestObject = {
        gameroomId: sessionStorage.getItem('GameroomID'),
        startDate: startDate,
        endDate: endDate
    };

    $.ajax({
        url: '/api/v1/extrachancesentriescount',
        type: 'POST',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}

function updateCounterDisplay(entryCount) {

    let $counterContainer = $('.enterticketscounter-entrycount-container');

    //fade out existing counteritems
    $counterContainer.find('.enterticketscounter-entrycount-counteritem span')
        //.removeClass('fade-in')
        .addClass('fade-out');

    //Delay updating dom until fade out is done
    setTimeout(function () {

        var entryCountSplit = entryCount.toString().split("");
        var entryCountArray;

        if (!entryCount || entryCount === 0) {
            entryCountArray = [0, 0];
        } else if (entryCount < 10) {
            entryCountSplit.unshift(0);
            entryCountArray = entryCountSplit;
        } else {
            entryCountArray = entryCountSplit;
        }

        let html = enterTicketsCounterTemplate({ data: { entryCountArray: entryCountArray } });
        $counterContainer.html(html);

        //Fade in new counteritems
        $counterContainer.find('.enterticketscounter-entrycount-counteritem span')
            .addClass('fade-in');

    }, 500);

}

module.exports = {
    getExtraChanceEntryCount: getExtraChancesEntryCount
}


// WEBPACK FOOTER //
// ./features/extrachances/enterticketscounter/extrachances-enterticketcounter.js